'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteralLoose(['\n  background-color: #fff;\n  -webkit-box-shadow: 0px 2px 6px 1px rgba(119,119,119,0.25);\n  -moz-box-shadow: 0px 2px 6px 1px rgba(119,119,119,0.25);\n  box-shadow: 0px 2px 6px 1px rgba(119,119,119,0.25);\n  box-sizing: border-box;\n  width: 100%;\n  height: 100%;\n  font-size: 13px;\n\n  ', '\n'], ['\n  background-color: #fff;\n  -webkit-box-shadow: 0px 2px 6px 1px rgba(119,119,119,0.25);\n  -moz-box-shadow: 0px 2px 6px 1px rgba(119,119,119,0.25);\n  box-shadow: 0px 2px 6px 1px rgba(119,119,119,0.25);\n  box-sizing: border-box;\n  width: 100%;\n  height: 100%;\n  font-size: 13px;\n\n  ', '\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n    font-size: 18px;\n    line-height: 22px;\n  '], ['\n    font-size: 18px;\n    line-height: 22px;\n  ']),
    _templateObject3 = _taggedTemplateLiteralLoose(['\n  width: 100%;\n  height:100%;\n  background: none;\n  border: none;\n  padding-bottom: 9px;\n  display: inline-grid;\n\n   ', '\n'], ['\n  width: 100%;\n  height:100%;\n  background: none;\n  border: none;\n  padding-bottom: 9px;\n  display: inline-grid;\n\n   ', '\n']),
    _templateObject4 = _taggedTemplateLiteralLoose(['\n    padding-bottom: 13px;\n  '], ['\n    padding-bottom: 13px;\n  ']),
    _templateObject5 = _taggedTemplateLiteralLoose(['\n  display: flex;\n  flex-direction: row;\n'], ['\n  display: flex;\n  flex-direction: row;\n']),
    _templateObject6 = _taggedTemplateLiteralLoose(['\n  padding: 10px ', ' 0 10px;\n  color: ', ';\n  font-family: ', ';\n  line-height: 18px;\n  width: 100%;\n  box-sizing: border-box;\n  text-align: ', ';\n  z-index: 5;\n  height: 26px;\n\n  ', '\n'], ['\n  padding: 10px ', ' 0 10px;\n  color: ', ';\n  font-family: ', ';\n  line-height: 18px;\n  width: 100%;\n  box-sizing: border-box;\n  text-align: ', ';\n  z-index: 5;\n  height: 26px;\n\n  ', '\n']),
    _templateObject7 = _taggedTemplateLiteralLoose(['\n    padding: 13px 13px 0 13px;\n    line-height: 22px;\n    height: 45px;\n  '], ['\n    padding: 13px 13px 0 13px;\n    line-height: 22px;\n    height: 45px;\n  ']),
    _templateObject8 = _taggedTemplateLiteralLoose(['\n  display: ', ';\n  width: 35px;  \n  height: 35px;\n  margin: 10px 10px 10px 0;\n  color: white;\n  font-weight: bold;\n  background: #04A2DC;\n  border-radius: 50%;\n  align-items: center;\n  text-align: center;\n  \n  ', '\n'], ['\n  display: ', ';\n  width: 35px;  \n  height: 35px;\n  margin: 10px 10px 10px 0;\n  color: white;\n  font-weight: bold;\n  background: #04A2DC;\n  border-radius: 50%;\n  align-items: center;\n  text-align: center;\n  \n  ', '\n']),
    _templateObject9 = _taggedTemplateLiteralLoose(['\n    width: 50px;  \n    height: 50px;\n  '], ['\n    width: 50px;  \n    height: 50px;\n  ']),
    _templateObject10 = _taggedTemplateLiteralLoose(['\n  width: 35px;\n  \n  ', '\n'], ['\n  width: 35px;\n  \n  ', '\n']),
    _templateObject11 = _taggedTemplateLiteralLoose(['\n    width: 50px;\n  '], ['\n    width: 50px;\n  ']),
    _templateObject12 = _taggedTemplateLiteralLoose(['\n  width:100%;\n  height: 130px;\n  position: relative;\n  margin-top: auto;\n  display: flex;\n  align-items: center;\n  ', '\n\n  ', '\n'], ['\n  width:100%;\n  height: 130px;\n  position: relative;\n  margin-top: auto;\n  display: flex;\n  align-items: center;\n  ', '\n\n  ', '\n']),
    _templateObject13 = _taggedTemplateLiteralLoose(['\n    height: 203px;\n  '], ['\n    height: 203px;\n  ']),
    _templateObject14 = _taggedTemplateLiteralLoose(['\n    height: 164px;\n  '], ['\n    height: 164px;\n  ']),
    _templateObject15 = _taggedTemplateLiteralLoose(['\n  max-width: 100%;\n  max-height: 100%;\n  padding: 0 5px;\n  margin: auto auto 0 auto;\n\n  ', '\n\n  ', '\n'], ['\n  max-width: 100%;\n  max-height: 100%;\n  padding: 0 5px;\n  margin: auto auto 0 auto;\n\n  ', '\n\n  ', '\n']),
    _templateObject16 = _taggedTemplateLiteralLoose(['\n    padding: 0 25px;\n  '], ['\n    padding: 0 25px;\n  ']),
    _templateObject17 = _taggedTemplateLiteralLoose(['\n    padding: 0 10px;\n  '], ['\n    padding: 0 10px;\n  ']),
    _templateObject18 = _taggedTemplateLiteralLoose(['\n  display: block;\n  text-align: center;\n  color: #A0877F;\n  font-family: ', ';\n  line-height: 14px;\n  margin-top: 8px;\n  width: 100%;\n  padding: 0 9px;\n\n  ', '\n'], ['\n  display: block;\n  text-align: center;\n  color: #A0877F;\n  font-family: ', ';\n  line-height: 14px;\n  margin-top: 8px;\n  width: 100%;\n  padding: 0 9px;\n\n  ', '\n']),
    _templateObject19 = _taggedTemplateLiteralLoose(['\n    line-height: 22px;\n    padding: 0 13px;\n  '], ['\n    line-height: 22px;\n    padding: 0 13px;\n  ']),
    _templateObject20 = _taggedTemplateLiteralLoose(['\n  text-align: left;\n  float: left;\n'], ['\n  text-align: left;\n  float: left;\n']),
    _templateObject21 = _taggedTemplateLiteralLoose(['\n  text-align: right;\n  width: 30%;\n  float: right;\n'], ['\n  text-align: right;\n  width: 30%;\n  float: right;\n']);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _styledComponentsHelper = require('../../lib/styledComponentsHelper');

var _image = require('../Image/image');

var _image2 = _interopRequireDefault(_image);

var _ADAHelpers = require('../../lib/ADAHelpers');

var _ADAHelpers2 = _interopRequireDefault(_ADAHelpers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

var ProductTileStyled = _styledComponents2.default.div(_templateObject, _styledComponentsHelper.media.md(_templateObject2));

var ProductTileLink = _styledComponents2.default.div(_templateObject3, _styledComponentsHelper.media.md(_templateObject4));

var TitleContainer = _styledComponents2.default.div(_templateObject5);

var ProductTitleStyled = _styledComponents2.default.div(_templateObject6, function (props) {
  return props.alignment === 'left' ? 0 : '10px';
}, _styledComponentsHelper.colors.text.primary.default, _styledComponentsHelper.fonts.bold, function (props) {
  return props.alignment;
}, _styledComponentsHelper.media.md(_templateObject7));

var NumberContainer = _styledComponents2.default.div(_templateObject8, function (props) {
  return props.display ? 'flex' : 'none';
}, _styledComponentsHelper.media.md(_templateObject9));

var NumberStyled = _styledComponents2.default.span(_templateObject10, _styledComponentsHelper.media.md(_templateObject11));

var ImageContainer = _styledComponents2.default.div(_templateObject12, _styledComponentsHelper.media.sm(_templateObject13), _styledComponentsHelper.media.md(_templateObject14));

var ProductImageStyled = (0, _styledComponents2.default)(_image2.default)(_templateObject15, _styledComponentsHelper.media.sm(_templateObject16), _styledComponentsHelper.media.md(_templateObject17));

var ProductCalorieStyled = _styledComponents2.default.div(_templateObject18, _styledComponentsHelper.fonts.book, _styledComponentsHelper.media.md(_templateObject19));

var ProductCalorieLeftStyled = _styledComponents2.default.div(_templateObject20);

var ProductCalorieRightStyled = _styledComponents2.default.div(_templateObject21);

var ProductTile = function ProductTile(props) {
  var altText = props.altText,
      cssClass = props.cssClass,
      calories = props.calories,
      displayName = props.displayName,
      imageUrl = props.imageUrl,
      onClick = props.onClick,
      price = props.price,
      _props$buttonProps = props.buttonProps,
      buttonProps = _props$buttonProps === undefined ? {} : _props$buttonProps;


  var caloriesDisplay = '';
  if (calories && price) {
    caloriesDisplay = _react2.default.createElement(
      'span',
      null,
      _react2.default.createElement(
        ProductCalorieLeftStyled,
        null,
        calories
      ),
      _react2.default.createElement(
        ProductCalorieRightStyled,
        null,
        '$',
        price
      )
    );
  } else if (calories) {
    caloriesDisplay = calories;
  }

  var buttonHelper = onClick ? { role: 'button', tabIndex: '0', onClick: onClick, onKeyDown: _ADAHelpers2.default.keyupHandler } : {};

  var titleAlignment = props.number ? 'left' : 'center';

  return _react2.default.createElement(
    ProductTileStyled,
    { className: "ProductTileStyled qa-menu-item-container " + props.class || '' },
    _react2.default.createElement(
      ProductTileLink,
      _extends({ className: 'qa-menu-item ' }, buttonHelper, buttonProps),
      _react2.default.createElement(
        TitleContainer,
        null,
        _react2.default.createElement(
          ProductTitleStyled,
          { alignment: titleAlignment, className: 'prod-title' },
          displayName
        ),
        _react2.default.createElement(
          NumberContainer,
          { display: !!props.number },
          _react2.default.createElement(
            NumberStyled,
            null,
            props.number
          )
        )
      ),
      _react2.default.createElement(
        ImageContainer,
        { className: 'prod-image-container' },
        _react2.default.createElement(ProductImageStyled, { className: 'prod-img', alt: altText, src: imageUrl, backupImage: '/images/common/img_product_placeholder.png', role: !altText ? 'presentation' : 'img' })
      ),
      _react2.default.createElement(
        ProductCalorieStyled,
        { className: 'prod-calories' },
        caloriesDisplay
      )
    ),
    props.children
  );
};

ProductTile.propTypes = {
  altText: _propTypes2.default.string,
  calories: _propTypes2.default.string,
  cssClass: _propTypes2.default.string,
  displayName: _propTypes2.default.string,
  imageUrl: _propTypes2.default.string.isRequired,
  onClick: _propTypes2.default.func,
  price: _propTypes2.default.number,
  number: _propTypes2.default.number
};

exports.default = ProductTile;


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/components/ProductTile/productTile.js
// module id = 209
// module chunks = 0